<div>
  <br />
  <div class="form-content">
    <p class="not-authorized-user-group">You are not authorized to this application</p> 
  </div>
</div>
